import React from "react";

export default function TextCarousel({
  text,
  color,
  colouredPosition,
}: {
  text: string;
  color?: string;
  colouredPosition: number;
}) {
  let texts = text.split(" ");
  let textColor: any;
  switch (color) {
    case "green":
      textColor = "text-[#37DED7]";
      break;
    case "purple":
      textColor = "text-purple"; // replace with your desired color
      break;
    case "blue":
      textColor = "text-blue-500"; // replace with your desired color
      break;
    // add more cases as needed
    default:
      textColor = "text-white";
  }
  return (
    <div className="inline-flex">
      <div className={`uppercase text-font-150 ${textColor} inline-flex`}>
        {[...Array(4)].map((_, j) => (
          <div
            key={j}
            className="inline-flex gap-x-4 pl-12 animate-slideToLeft"
          >
            {texts.map((text, i) => {
              return (
                <span
                  key={`${j}-${i}`}
                  className={`${i === colouredPosition
                      ? textColor
                      : `text-transparent 
                                            ${color
                        ? `text-stroke-${color}`
                        : "text-stroke"
                      }`
                    } font-bold`}
                >
                  {text}
                </span>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
